module.exports = __webpack_public_path__ + "media/images/front/pricing_flow/success-7db0ffbeff63ab8eb401c78a6b857b5a.svg";